const headers = {
  name: "Product unit",
  navigate: {
    tabs: [
      {
        name: "Units",
        path: "/app/products/units",
      },
      {
        name: "Add",
        path: "",
      },
    ],
  },
};

export default headers;
